import React from 'react';
import FooterSection from '../Components/footer/FooterSection';
import HireUs from '../Components/hireUs/HireUs';
import Services from '../Components/Services/Services'

const ServicesPage = () => {
    return (
        <div>
            <Services />
        </div>
    )
}

export default ServicesPage
